import constants from '../constants';
import { getElementId, hasLockedParent } from '../../helpers';

interface IframeSources {
	defaultSrc: string;
	src: string;
}

export interface IframeConfig extends IframeSources {
	id: string;
	page: number;
	isEditedFromBackoffice: boolean;
	isVisible: boolean;
}

interface IframesData {
	items: IframeConfig[];
	isError: boolean;
}

export enum IframeElementDataAttribute {
	edited = 'data-edited', // is set to iframe when it was modified in backoffice
	defaultSrc = 'data-default-src', // is set to iframe to store default src
	src = 'data-src', // is set to iframe to store src
	hidden = 'data-hidden', // is set when iframe is hidden
}

const getElementSources = (element: HTMLIFrameElement, isEditedFromBackoffice: boolean, isVisible: boolean): IframeSources => {
	if (isEditedFromBackoffice) {
		return {
			defaultSrc: element.getAttribute(IframeElementDataAttribute.defaultSrc) || '',
			src: element.getAttribute(IframeElementDataAttribute.src) || '',
		};
	}

	const defaultSrc = isVisible
		? element.src
		: element.getAttribute(IframeElementDataAttribute.defaultSrc) || '';

	return {
		defaultSrc,
		src: defaultSrc,
	};
};

const getConfig = (element: HTMLIFrameElement, page: number): IframeConfig => {
	const id = getElementId(element);
	const isEditedFromBackoffice = element.getAttribute(IframeElementDataAttribute.edited) === 'true';
	const isVisible = !(element.getAttribute(IframeElementDataAttribute.hidden) &&
		element.getAttribute(IframeElementDataAttribute.hidden) === 'true');

	return {
		page,
		id,
		isEditedFromBackoffice,
		isVisible,
		...getElementSources(element, isEditedFromBackoffice, isVisible),
	};
};

export default (page: number, htmlDocument: Document): IframesData => {
	const items: IframeConfig[] = [];
	let isError: boolean = false;

	const iframeElements = ([
		...htmlDocument.querySelectorAll(`[class*=${constants.iframeClassName}]`),
	] as HTMLIFrameElement[]).filter(element => !hasLockedParent(element));

	try {
		iframeElements.forEach(element => (
			items.push(getConfig(element, page))
		));
	} catch (err) {
		isError = true;
	}

	return {
		items,
		isError,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableIframes/getData.ts